import 'twin.macro';
import 'styled-components/macro';

import { HTMLAttributes, forwardRef } from 'react';

export interface CheckboxTriggerProps extends HTMLAttributes<HTMLButtonElement> {}

export const CheckboxTrigger = forwardRef<HTMLButtonElement, CheckboxTriggerProps>((props, forwardedRef) => (
  <button
    {...props}
    type="button"
    ref={forwardedRef}
    tw="
      w-3
      h-3
      shrink-0

      bg-white
      border
      border-gray-15
      rounded
      overflow-hidden

      outline-none
      focus-within:(border-secondary ring-4 ring-secondary-lighter)
      [&:not([data-disabled])]:(hover:(ring-4 ring-secondary-lighter))"
  />
));
